import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { api, getAccessToken } from '@eon/api-client';
import { hasRole, type Role, type User } from '@eon/types';

export async function ensureAuthenticated(): Promise<void> {
  if (!getAccessToken()) {
    throw redirect({ to: '/login' });
  }
}

export async function loadCurrentUser(queryClient: QueryClient): Promise<User> {
  const cached = queryClient.getQueryData<User>(['me']);
  if (cached) return cached;

  const user = await api().get<User>('/my/profile');
  queryClient.setQueryData(['me'], user);
  return user;
}

export async function ensureRole(
  queryClient: QueryClient,
  allowed: readonly Role[],
): Promise<User> {
  await ensureAuthenticated();
  const user = await loadCurrentUser(queryClient);

  if (!hasRole(user.role, allowed)) {
    throw redirect({ to: '/forbidden' });
  }

  return user;
}
